export default "__VITE_ASSET__CaUTY6NY__"